
import { SearchBaseModel } from '../commonModels';
import { DateRange } from '../commonModels';

export class OrderSearchModel extends SearchBaseModel {

  constructor() {
    super();
    this.GarageId = null;
    this.CustomerId = null;
    this.Garage = null;
    this.Customer = null;
    this.RegistrationNumber = null;
    this.ShipmentNumber = null;
    this.Number = null;
    this.Date0 = null;
    this.Date1 = null;
    this.Period = null;
    this.PeriodDateRange = new DateRange();

    this.OrderTypeId = null;
    this.OrderStatusId = null;
    this.IsCanceled = null;
    this.IsExecuted = null;
    this.IsOnGoing = null;
    this.IsOverdue = null;
    this.IsCancelRequest = null;

    this.CarId = null;
    this.IsWithdrawed = null;
  }

  public GarageId: number;
  public CustomerId: number;
  public RegistrationNumber: string;
  public ShipmentNumber: string;
  public Garage: string;
  public Customer: string;
  public Number: string;
  public Date0: Date;
  public Date1: Date;
  public Period: any;
  public PeriodDateRange: DateRange;
  public OrderTypeId: number;
  public OrderStatusId: number;
  public IsCanceled: boolean;
  public IsExecuted: boolean;
  public GuardianId: number;
  public IsOnGoing: boolean;
  public IsOverdue: boolean;
  public CarId: number;
  public IsCancelRequest: boolean;
  public IsAPIRequest: boolean;
  public HasNotes: boolean;
  public CourierId: number;
  public HasCourierPikupDate: boolean;
  public IsWithdrawed: boolean;
}

